var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('invite-form',{attrs:{"title":"Informações do usuário"},on:{"closeForm":_vm.closeInviteForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }